module.exports = __webpack_public_path__ + "img/126_FIFA.98813b2c.jpg";